'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { HORIZONTAL, VERTICAL } from 'DesignData/enums/AxisDirections';

const Resizer = ({
  disabled,
  direction,
  onMouseDown,
  className
}) => {
  const resizerClassName = classNames(className, 'resizer', direction === VERTICAL ? 'is--vertical' : 'is--horizontal', disabled && 'is--disabled');
  return /*#__PURE__*/_jsx("div", {
    className: resizerClassName,
    onMouseDown: onMouseDown
  });
};

Resizer.propTypes = {
  disabled: PropTypes.bool,
  direction: PropTypes.oneOf([HORIZONTAL, VERTICAL]).isRequired,
  onMouseDown: PropTypes.func.isRequired,
  className: PropTypes.string
};
export default Resizer;